import { config } from '@/config';

export function getWebSocketUrl(): string {
    return `${config.adpWebSocketUrl}/job_monitoring_channel`;
}